import { render, staticRenderFns } from "./DilekceList.vue?vue&type=template&id=019b2fd2&scoped=true"
import script from "./DilekceList.vue?vue&type=script&lang=ts"
export * from "./DilekceList.vue?vue&type=script&lang=ts"
import style0 from "./DilekceList.vue?vue&type=style&index=0&id=019b2fd2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b2fd2",
  null
  
)

export default component.exports